import styled from 'styled-components'
import { colors, fonts, updatedMedia } from 'client/styles'

export const FiltersSection = styled.div`
  background-color: ${colors.white};
  font-family: ${fonts.default};
  border-radius: 8px;
  border: 2px solid ${colors.grey4};
  margin-block: 15px;
  margin-inline: 0;

  ${updatedMedia.tablet} {
    flex: 0 0 auto;
  }
`

export const FilterTitle = styled.h6`
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
  border-block-end: 2px solid ${colors.grey4};
  padding-block: 15px;
  padding-inline: 20px;
  margin-block: 0 15px;
  margin-inline: 0;
`

export const ButtonWrapper = styled.div`
  background-color: ${colors.white};
  inset-block-end: 0;
  box-shadow: 0px -1px 2px 0px rgba(0, 0, 0, 0.15);
  display: flex;
  padding-block: 0.75em;
  padding-inline: 0.75em;
  inset-inline-start: 0;
  position: fixed;
  width: 100%;

  span {
    flex: 1;
  }

  span:first-child {
    margin-inline-end: 0.75em;
  }

  ${updatedMedia.tablet} {
    box-shadow: none;
    padding-block: 1em;
    padding-inline: 1em;
    position: relative;
  }
`

export const Button = styled.span`
  border-radius: 4px;
  cursor: pointer;
  display: block;
  font-weight: 700;
  overflow: hidden;
  padding-block: 1em;
  padding-inline: 1em;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ButtonReset = styled(Button)`
  background-color: ${colors.white};
  border: 2px solid ${colors.grey4};
  color: ${colors.grey1};
  flex: 0 1 100px;
`

export const ButtonSubmit = styled(Button)`
  background-color: ${colors.magenta};
  border: 2px solid ${colors.magenta};
  color: ${colors.white};
  flex: 1 0 auto;
`

export const Aside = styled.div`
  width: 324px;
`

export const FilterModalSection = styled.div`
  margin-block-end: 75px;
`
